<template>
  <div id="tutorial">
    <div class="inner-wrapper">
      <main class="inner-content">
        <header>
          <p class="intro-copy">MS Disease Progression Visualizer</p>
          <h1 v-show="!next" class="app-title">How to use this tool</h1>
          <h1 v-show="next" class="app-title">
            Move the slider below to begin
          </h1>
        </header>
        <div v-show="!next" class="tutorial-img-1">
          <img
            src="@/assets/img/tutorial-mobile.png"
            class="tutorial-image mobile"
            alt=""
          />
          <img
            src="@/assets/img/tutorial-tablet.png"
            class="tutorial-image tablet"
            alt=""
          />
          <img
            src="@/assets/img/tutorial-desktop.png"
            class="tutorial-image desktop"
            alt=""
          />
          <div class="next-btn">
            <a href="#" @click="[(next = true), updateAnalytics()]">
              <span>Next</span>
              <img src="@/assets/img/icon-back-arrow.svg" class="icon" />
            </a>
          </div>
        </div>
        <div v-show="next" class="tutorial-img-2">
          <!-- <p>Lorem ipsum dolor sit amet consectetur adipisicing elit. Deserunt fugiat inventore a. Iure temporibus optio quod odio impedit placeat eligendi, quis commodi maiores tempore eius dolore ipsam doloribus delectus debitis vero hic laudantium qui laboriosam quibusdam nihil! Provident sed, facere, odio repellendus, error iste architecto qui eum eligendi mollitia atque.</p> -->
          <FindingsTutorial />
        </div>
      </main>
    </div>
  </div>
</template>

<script>
import FindingsTutorial from "@/components/FindingsTutorial.vue";

export default {
  name: "Tutorial",
  components: {
    FindingsTutorial,
  },
  data() {
    return {
      next: false,
    };
  },
  beforeMount() {
    this.$store.updateYear(0);
  },
  mounted() {
    this.$pauseSound();
    this.$store.toggleAudio(false);
    this.$store.updateYear(0);
  },
  methods: {
    updateAnalytics: function () {
      this.$gtag.event("click", {
        event_category: `select_tutorial_next`,
        event_label: "tutorial-next",
      });
    },
  },
};
</script>

<style lang="scss" scoped>
#tutorial {
  width: 100%;
  position: relative;

  .tutorial-img-1,
  .tutorial-img-2 {
    img {
      width: 100%;
    }
  }

  &:before {
    content: "";
    width: 100%;
    height: 55%;
    position: absolute;
    top: 0;
    left: 0;
    background: linear-gradient(
      180deg,
      rgba($blue-dark-bg, 1) 0%,
      rgba($blue-dark-bg, 0) 100%
    );
  }

  &:after {
    content: "";
    width: 100%;
    height: 30%;
    position: absolute;
    bottom: 0;
    left: 0;
    background: linear-gradient(
      180deg,
      rgba($blue-dark-bg, 0) 0%,
      rgba($blue-dark-bg, 1) 100%
    );
  }

  // Issue #94: iPad specific media query
  // @media only screen and (min-device-width: 768px) and (max-device-width: 1024px) and (orientation: landscape) and (-webkit-min-device-pixel-ratio: 1) {
  //   // height: calc(100vh - 104px - 32px);
  // }
}

.app-title {
  font-size: rem(36px);
  margin-top: rem(20px);
  margin-bottom: rem(40px);
  text-align: center;
}

.intro-copy {
  margin-bottom: rem(25px);
  font-size: rem(18px);
  text-align: center;
  @media screen and (orientation: portrait) {
    width: 100%;
    font-size: rem(20px);
  }
}

.inner-wrapper {
  padding-bottom: rem(100px);
  position: relative;
  z-index: 1;
}

.next-btn {
  display: flex;
  justify-content: flex-end;
  font-size: rem(14px);
  a {
    display: flex;
    width: 60px;
    text-decoration: none;
  }
  .icon {
    transform: rotate(180deg);
    margin-left: 7px;
  }
}

.tutorial-image {
  display: none;
  &.mobile {
    @include breakpoint(xs) {
      display: block;
    }
  }
  &.tablet {
    @include breakpoint(md) {
      display: block;
    }
  }
  &.desktop {
    @include breakpoint(lg) {
      display: block;
    }
  }
}
</style>
